import { render, staticRenderFns } from "./DirectionsAboutCompanyBlock.vue?vue&type=template&id=28e2b8db&scoped=true&"
import script from "./DirectionsAboutCompanyBlock.vue?vue&type=script&lang=js&"
export * from "./DirectionsAboutCompanyBlock.vue?vue&type=script&lang=js&"
import style0 from "./DirectionsAboutCompanyBlock.vue?vue&type=style&index=0&id=28e2b8db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2b8db",
  null
  
)

export default component.exports